



































import { Component, Vue } from 'vue-property-decorator';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import DateFilter from '@/components/molecules/DateFilter/DateFilter.vue';
import ArrowWithBorder from '@/components/atoms/ArrowWithBorder/ArrowWithBorder.vue';
import PerformanceActivitiesTotalSpendCustomers from '@/componentsV2/templates/PerformanceActivitiesTotalSpendCustomers/PerformanceActivitiesTotalSpendCustomers.vue';
import { IPeriod } from '@/models/period';
import PerformanceUtils from '@/utils/PerformanceUtils';
import ActivitiesTotalSpend from '@/componentsV2/organisms/ActivitiesTotalSpend/ActivitiesTotalSpend.vue';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    SectionWrapper,
    DateFilter,
    ArrowWithBorder,
    ActivitiesTotalSpend,
    GhostButton,
    PerformanceActivitiesTotalSpendCustomers
  }
})
export default class PerformanceActivitiesTotalSpend extends Vue {
  showGraffic = this.cachedCustomersSpendToggleState || false;
  period: IPeriod = PerformanceUtils.defaultPeriod();
  filters: Record<string, any> = {
    ...PerformanceUtils.defaultPeriodForFilter()
  };

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    return `performance.activities.totalSpend`;
  }

  get labelBottomBtn() {
    return this.showGraffic
      ? this.$t(`${this.tPrefix}.bottomBtn.titleOpened`)
      : this.$t(`${this.tPrefix}.bottomBtn.titleClosed`);
  }

  get cachedCustomersSpendToggleState() {
    return this.$store.getters['performance/getActivityState']
      .customersSpendOpened;
  }

  handleToggle() {
    const newShowGrafficState = !this.showGraffic;

    this.showGraffic = newShowGrafficState;
    this.$store.dispatch(
      'performance/SET_ACTIVITY_CUSTOMERS_SPEND_TOGGLE',
      newShowGrafficState
    );
  }
}
